/* eslint-disable no-console */

import axios from 'axios'
import { openDB } from 'idb'
import config from '../config'
import authorization from './Authentication'

export class Api {
    constructor(baseUrl, authentication) {
        this.baseUrl = baseUrl
        this.authentication = authentication
    }

    get = async api => {
        axios.defaults.baseURL = this.baseUrl
        const { access_token } = await this.authentication.getUser()
        axios.defaults.headers.common[
            'Authorization'
        ] = `Bearer ${access_token}`

        return axios
            .get(api)
            .then(response => response.data)
    }

    // createIndexedDb = () =>
    //     openDB('scanning', 2, {
    //         upgrade(db) {
    //             if (!db.objectStoreNames.contains('events')) {
    //                 db.createObjectStore(`events`, { keyPath: 'id' })
    //             }

    //             if (!db.objectStoreNames.contains('attendees')) {
    //                 db.createObjectStore(`attendees`, { keyPath: 'ticketId' })
    //                 store.createIndex('by-event', ['eventId', 'ticketId'], {
    //                     unique: true,
    //                 })
    //             }
    //         },
    //         blocked() {},
    //         blocking() {},
    //     })

    // saveLocally = (objectStoreName, items) =>
    //     this.createIndexedDb().then(db => {
    //         const tx = db.transaction(objectStoreName, 'readwrite')
    //         const store = tx.objectStore(objectStoreName)
    //         return Promise.all(items.map(item => store.put(item))).catch(() => {
    //             tx.abort()
    //             throw Error('Items were not added to the store')
    //         })
    //     })

    // getLocally = objectStoreName =>
    //     this.createIndexedDb().then(db => {
    //         const tx = db.transaction(objectStoreName, 'readonly')
    //         const store = tx.objectStore(objectStoreName)
    //         return store.getAll()
    //     })

    getEvents = () => this.get(`/api/events`).then(response => response.events)

    getEvent = eventId => this.get(`/api/events/${eventId}`)

    getAttendees = eventId => this.get(`/api/attendees/${eventId}`).then(response => response.attendees)
        // new Promise((resolve, reject) => {
        //     this.get(`/api/attendees/${eventId}`)
        //         .then(response => {
        //             if (!('indexedDB' in window)) {
        //                 resolve(response.attendees)
        //                 return
        //             }

        //             this.saveLocally(
        //                 'attendees',
        //                 response.attendees.map(attendee => ({
        //                     ...attendee,
        //                     eventId,
        //                 }))
        //             )
        //                 .then(() => resolve(response.attendees))
        //                 .catch(error => reject(error))
        //         })
        //         .catch(error => {
        //             console.log(
        //                 'Network requests have failed, this is expected if offline'
        //             )
        //             this.getLocally('attendees')
        //                 .then(attendees => resolve(attendees))
        //                 .catch(error => reject(error))
        //         })
        // })
}

export default new Api(config.API_URI, authorization)
